<template>
  <div class="approve-fail">
    <OperationModal
      ref="operationModalRef"
      :columns="columns"
      :tableData="tableData"
      :loading="loading"
      :title="`失败明细`"
    >
      <template v-slot:modal-header>
        <div class="header">
          <Button type="primary" @click="handleDownload">下载</Button>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div class="footer-wrap">
          <div class="page-wrap">
            <Page
              :current="pageInfo.pageNum"
              :total="pageInfo.total"
              :page-size="pageInfo.pageSize"
              show-total
              show-elevator
              @on-change="pageChange"
            ></Page>
          </div>
        </div>
      </template>
    </OperationModal>
  </div>
</template>

<script>
import OperationModal from './OperationModal.vue'
import financeCenterApi from '@/request/financeCenter/index.js'
import { failColumns } from '../data/index'
import { downloadReport } from '@/utils/utils'
export default {
  props: {
    sheetId: {
      type: String,
      default: ''
    }
  },
  components: {
    OperationModal
  },
  data() {
    return {
      show: false,
      loading: false,
      columns: failColumns,
      actType: 1, // 1:运营考勤确认 2：学校考勤确认
      tableData: [],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      portOrg: localStorage.getItem('portOrg')

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleShow(actType) {
      this.$refs.operationModalRef.handleOpen()
      this.show = true
      this.actType = actType
      this.pageInfo.pageNum = 1
      this.tableData = []
      this.getSchoolSettleApproveRecords()
    },
    pageChange(pageNum) {
      this.pageInfo.pageNum = pageNum
      this.getSchoolSettleApproveRecords()
    },
    handleHide() {
      this.show = false
    },
    // 列表
    async getSchoolSettleApproveRecords() {
      this.loading = true
      let res = await financeCenterApi.getSchoolSettleApproveRecordsApi({
        sheetId: this.sheetId,
        actType: this.actType,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      })
      this.loading = false
      if (res.status == 200) {
        this.pageInfo.total = Number(res.message.total)
        this.tableData = res.message.list
      }
    },
    // 导出
    async handleDownload(type) {
      let params = {
        sheetId: this.sheetId,
        actType: this.actType,
        checkRslt: 2
      }
      let url = null;
      if (this.portOrg == 0) {
        url = `${process.env.VUE_APP_API_ORDER_URL}/admin/settlementSheetSch/exportSchoolSettleApproveRecords`
      } else if (this.portOrg == 2) {
        url = `${process.env.VUE_APP_API_ORDER_URL}/school/settlementSheetSch/exportSchoolSettleApproveRecords`
      }

      downloadReport(url, params, this)
    },
  }
}
</script>

<style lang="scss" scoped>
.header {
  text-align: right;
  margin-bottom: 16px;
}
</style>